import { CounterofferStep } from '../interfaces/interface.offer';
import EventBus from '../services/service.eventBus';
import { updateCounteroffer } from '../services/service.offer';
import { state } from '../store/store.counteroffer';
import { state as offerState } from '../store/store.offer';
import { onChange as onOptimizelyChange, state as optimizelyState } from '../store/store.optimizely';
import { onChange as onPageParamsChange, state as pageParamsState } from '../store/store.page-params';
import track from '../tracking/tracking.counteroffer';
import { asMMDDYYYY } from '../utils/utils.time-format';

const onUpdateFromOffer = (data) => {
  const { hasManualBoost, acceptOrCounterofferAmount, confirmedDate } = data || {};
  state.confirmedDate = confirmedDate && asMMDDYYYY(confirmedDate);
  state.hasManualBoost = hasManualBoost;
  state.amount = acceptOrCounterofferAmount;
  state.hasDataObject = !!data;
  updateShouldDisplay();
};

export const onCounterofferInit = () => {
  onOptimizelyChange('acceptOrCounterofferON', updateShouldDisplay);
  onOptimizelyChange('acceptOrCounterofferUnassignedON', updateShouldDisplay);
  onPageParamsChange('isAdmin', updateShouldDisplay);
  updateShouldDisplay();
};
const updateShouldDisplay = () => {
  const submitted = state.amount >= 0;
  const isAssignedOrUnassignedCounterofferFlagOn =
    (offerState.isAssignedOffer && optimizelyState.acceptOrCounterofferON) || (!offerState.isAssignedOffer && optimizelyState.acceptOrCounterofferUnassignedON);
  const shouldDisplayWhenNotSubmitted = state.hasDataObject && !state.hasManualBoost && isAssignedOrUnassignedCounterofferFlagOn;
  state.shouldDisplay = !pageParamsState.isAdmin && (submitted || shouldDisplayWhenNotSubmitted) && !offerState.isDrOffer;
};

export const onAcceptOffer = () => onUpdateAmount(0);

const onSubmitCounteroffer = () => onUpdateAmount(state.inputAmount);

const onResetCounterofferState = () => {
  state.currentStep = 0;
  state.inputAmount = null;
  state.error = '';
};

const onUpdateInputAmount = (amount: string) => {
  state.inputAmount = parseInt(amount) || null;
  if (state.error && state.inputAmount) {
    state.error = null;
  }
};

const onMoveToReview = () => {
  if (state.inputAmount) {
    state.currentStep = CounterofferStep.Review;
    track.counteroffer.make();
  } else {
    state.error = 'Please input your counteroffer.';
  }
};

const onReturnToInput = () => {
  state.currentStep = CounterofferStep.Input;
  track.counteroffer.edit();
};

const onUpdateAmount = (amount: number) => {
  state.isSubmitting = true;
  updateCounteroffer(offerState.offerId, amount)
    .then(() => onUpdateCounterofferSuccess(amount))
    .catch((error) => onUpdateCounterofferFailure(error))
    .finally(() => onUpdateCounterofferComplete());
  EventBus.publish('UpdateCounteroffer', { amount });
};
const onUpdateCounterofferSuccess = (amount: number) => {
  state.amount = amount;
  if (amount > 0) {
    state.currentStep = CounterofferStep.Submitted;
    track.counteroffer.submit();
  } else {
    track.acceptOffer.yes();
  }
  EventBus.publish('UpdateCounterofferSuccess', { amount });
};
const onUpdateCounterofferFailure = (error: object) => {
  EventBus.publish('UpdateCounterofferFailure', error);
};
const onUpdateCounterofferComplete = () => {
  state.isSubmitting = false;
  EventBus.publish('UpdateCounterofferComplete', {});
};

export default {
  onUpdateFromOffer,
  onCounterofferInit,
  onAcceptOffer,
  onSubmitCounteroffer,
  onResetCounterofferState,
  onUpdateInputAmount,
  onMoveToReview,
  onReturnToInput,
  updateShouldDisplay,
};
